import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home.vue"

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Home",
		meta: {index: 0},
		component: Home
	},
	{
		path: "/catalog",
		name: "Catalog",
		meta: {index: 10},
		component: () => import(/* webpackChunkName: "catalog" */ "../views/Catalog.vue")
	},
	{
		path: "/catalog/:id",
		name: "CatalogWithID",
		meta: {index: 20},
		component: () => import(/* webpackChunkName: "catalog_id" */ "../views/Catalog.vue")
	},
	{
		path: "/details/:id",
		name: "Details",
		meta: {index: 25},
		component: () => import(/* webpackChunkName: "details" */ "../views/Details.vue")
	},
	{
		path: "/support",
		name: "Support",
		meta: {index: 30},
		component: () => import(/* webpackChunkName: "support" */ "../views/Support.vue")
	},
	{
		path: "/downloads",
		name: "Downloads",
		meta: {index: 35},
		component: () => import(/* webpackChunkName: "downloads" */ "../views/Downloads.vue")
	},
	{
		path: "/blog",
		name: "Blog",
		meta: {index: 40},
		component: () => import(/* webpackChunkName: "blog" */ "../views/Blog.vue")
	},
	{
		path: "/news/:id",
		name: "News",
		meta: {index: 45},
		component: () => import(/* webpackChunkName: "news" */ "../views/News.vue")
	},
	{
		path: "/about",
		name: "About",
		meta: {index: 50},
		component: () => import(/* webpackChunkName: "about" */ "../views/About.vue")
	}
];

const router = new VueRouter({
	mode: "history",
	routes,
	scrollBehavior(to, from, savedPosition) {
		return new Promise((resolve) => {
			if ((to.path.indexOf("catalog") !== -1)
				&& (from.path.indexOf("catalog") !== -1)) {
				resolve({});
			} else {
				setTimeout(() => {
					if (savedPosition) {
						resolve(savedPosition);
					} else if (to.hash) {
						resolve({selector: to.hash});
					} else {
						resolve({x: 0, y: 0});
					}
				}, 300);
			}
		});

	}
});

export default router
